module.exports = __webpack_public_path__ + "img/banner-home-5.ee145c44.jpg";